import { render } from "./PreseedingDistricts.vue?vue&type=template&id=7dbe3663&scoped=true"
import script from "./PreseedingDistricts.vue?vue&type=script&lang=js"
export * from "./PreseedingDistricts.vue?vue&type=script&lang=js"

import "./PreseedingDistricts.vue?vue&type=style&index=0&id=7dbe3663&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbe3663"]])

export default __exports__